export default __webpack_public_path__ + "static/media/21-move.11fa401b.png";